import ExcerptionsListRow from './excerptions-list-row'

export default ExcerptionsListRow
